/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [导购智能体首页↗](https://yapi.fenxianglife.com/project/379/interface/api/44932) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/guideConfigs`
 * @更新时间 `2023-10-31 16:22:10`
 */
export const feimaChatTkGuideConfigs = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGuideConfigsRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGuideConfigsResponse, OT>>(
    '/tk/guideConfigs',
    'POST',
    data,
    options
  );

/**
 * 接口 [校验pid↗](https://yapi.fenxianglife.com/project/379/interface/api/44938) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/checkPid`
 * @更新时间 `2023-10-24 14:50:25`
 */
export const feimaChatTkCheckPid = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatTkCheckPidRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkCheckPidResponse, OT>>(
    '/tk/checkPid',
    'GET',
    data,
    options
  );

/**
 * 接口 [智能导购详情↗](https://yapi.fenxianglife.com/project/379/interface/api/44944) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/getGuideConfig`
 * @更新时间 `2024-02-27 14:45:02`
 */
export const feimaChatTkGetGuideConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetGuideConfigRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetGuideConfigResponse, OT>>(
    '/tk/getGuideConfig',
    'GET',
    data,
    options
  );

/**
 * 接口 [问答智能体列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44950) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/getCommBots`
 * @更新时间 `2023-10-23 11:45:48`
 */
export const feimaChatTkGetCommBots = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatTkGetCommBotsRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetCommBotsResponse, OT>>(
    '/tk/getCommBots',
    'GET',
    data,
    options
  );

/**
 * 接口 [群列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44956) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/getGroups`
 * @更新时间 `2023-10-30 17:22:44`
 */
export const feimaChatTkGetGroups = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetGroupsRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetGroupsResponse, OT>>(
    '/tk/getGroups',
    'POST',
    data,
    options
  );

/**
 * 接口 [更新智能导购↗](https://yapi.fenxianglife.com/project/379/interface/api/44962) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/updateGuide`
 * @更新时间 `2024-02-27 14:11:24`
 */
export const feimaChatTkUpdateGuide = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkUpdateGuideRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkUpdateGuideResponse, OT>>(
    '/tk/updateGuide',
    'POST',
    data,
    options
  );

/**
 * 接口 [查看对话数据-废弃↗](https://yapi.fenxianglife.com/project/379/interface/api/44968) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/getGuideDialogues2`
 * @更新时间 `2023-10-26 13:45:34`
 */
export const feimaChatTkGetGuideDialogues2 = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetGuideDialogues2Request>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatTkGetGuideDialogues2Response, OT>
  >('/tk/getGuideDialogues2', 'POST', data, options);

/**
 * 接口 [添加屏蔽微信号↗](https://yapi.fenxianglife.com/project/379/interface/api/44974) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/addWorker`
 * @更新时间 `2023-10-31 19:15:07`
 */
export const feimaChatTkAddWorker = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkAddWorkerRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAddWorkerResponse, OT>>(
    '/tk/addWorker',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除屏蔽微信号↗](https://yapi.fenxianglife.com/project/379/interface/api/44980) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/deleteWorker`
 * @更新时间 `2023-10-31 19:15:23`
 */
export const feimaChatTkDeleteWorker = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkDeleteWorkerRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkDeleteWorkerResponse, OT>>(
    '/tk/deleteWorker',
    'POST',
    data,
    options
  );

/**
 * 接口 [屏蔽人列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44986) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/getWorkers`
 * @更新时间 `2023-10-23 11:53:34`
 */
export const feimaChatTkGetWorkers = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetWorkersRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetWorkersResponse, OT>>(
    '/tk/getWorkers',
    'POST',
    data,
    options
  );

/**
 * 接口 [氛围智能体首页↗](https://yapi.fenxianglife.com/project/379/interface/api/44992) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/getNpcs`
 * @更新时间 `2023-10-31 16:06:40`
 */
export const feimaChatTkGetNpcs = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetNpcsRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetNpcsResponse, OT>>(
    '/tk/getNpcs',
    'POST',
    data,
    options
  );

/**
 * 接口 [氛围智能体详情↗](https://yapi.fenxianglife.com/project/379/interface/api/44998) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/getGuideNpc`
 * @更新时间 `2023-10-31 16:55:42`
 */
export const feimaChatTkGetGuideNpc = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatTkGetGuideNpcRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetGuideNpcResponse, OT>>(
    '/tk/getGuideNpc',
    'GET',
    data,
    options
  );

/**
 * 接口 [添加氛围智能体微信号↗](https://yapi.fenxianglife.com/project/379/interface/api/45004) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/addNPC`
 * @更新时间 `2023-10-23 18:52:25`
 */
export const feimaChatTkAddNpc = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkAddNpcRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAddNpcResponse, OT>>(
    '/tk/addNPC',
    'POST',
    data,
    options
  );

/**
 * 接口 [更新氛围智能体↗](https://yapi.fenxianglife.com/project/379/interface/api/45010) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/updateGuideNpc`
 * @更新时间 `2023-10-31 19:16:23`
 */
export const feimaChatTkUpdateGuideNpc = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkUpdateGuideNpcRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkUpdateGuideNpcResponse, OT>>(
    '/tk/updateGuideNpc',
    'POST',
    data,
    options
  );

/**
 * 接口 [剧本首页↗](https://yapi.fenxianglife.com/project/379/interface/api/45016) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/getScripts`
 * @更新时间 `2023-10-31 16:24:09`
 */
export const feimaChatTkGetScripts = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetScriptsRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetScriptsResponse, OT>>(
    '/tk/getScripts',
    'POST',
    data,
    options
  );

/**
 * 接口 [添加剧本↗](https://yapi.fenxianglife.com/project/379/interface/api/45022) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/addScript`
 * @更新时间 `2023-10-31 19:16:56`
 */
export const feimaChatTkAddScript = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkAddScriptRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAddScriptResponse, OT>>(
    '/tk/addScript',
    'POST',
    data,
    options
  );

/**
 * 接口 [更新剧本↗](https://yapi.fenxianglife.com/project/379/interface/api/45028) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/updateScript`
 * @更新时间 `2023-10-31 19:17:18`
 */
export const feimaChatTkUpdateScript = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkUpdateScriptRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkUpdateScriptResponse, OT>>(
    '/tk/updateScript',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除剧本↗](https://yapi.fenxianglife.com/project/379/interface/api/45034) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/deleteScripts`
 * @更新时间 `2023-10-31 21:21:18`
 */
export const feimaChatTkDeleteScripts = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkDeleteScriptsRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkDeleteScriptsResponse, OT>>(
    '/tk/deleteScripts',
    'POST',
    data,
    options
  );

/**
 * 接口 [剧本关联群查询↗](https://yapi.fenxianglife.com/project/379/interface/api/45040) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/getScriptGroups`
 * @更新时间 `2023-10-23 16:53:20`
 */
export const feimaChatTkGetScriptGroups = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetScriptGroupsRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatTkGetScriptGroupsResponse, OT>
  >('/tk/getScriptGroups', 'POST', data, options);

/**
 * 接口 [剧本触发记录↗](https://yapi.fenxianglife.com/project/379/interface/api/45046) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/getScriptLogs`
 * @更新时间 `2023-10-23 16:53:27`
 */
export const feimaChatTkGetScriptLogs = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetScriptLogsRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetScriptLogsResponse, OT>>(
    '/tk/getScriptLogs',
    'POST',
    data,
    options
  );

/**
 * 接口 [授权账号列表↗](https://yapi.fenxianglife.com/project/379/interface/api/45052) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/account/list`
 * @更新时间 `2023-10-23 12:00:35`
 */
export const feimaChatTkAccountList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatTkAccountListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAccountListResponse, OT>>(
    '/tk/account/list',
    'GET',
    data,
    options
  );

/**
 * 接口 [账号授权↗](https://yapi.fenxianglife.com/project/379/interface/api/45058) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/account/auth`
 * @更新时间 `2023-10-23 12:01:00`
 */
export const feimaChatTkAccountAuth = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkAccountAuthRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAccountAuthResponse, OT>>(
    '/tk/account/auth',
    'POST',
    data,
    options
  );

/**
 * 接口 [增加pid↗](https://yapi.fenxianglife.com/project/379/interface/api/45064) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/account/pid/add`
 * @更新时间 `2023-10-23 12:01:14`
 */
export const feimaChatTkAccountPidAdd = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkAccountPidAddRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAccountPidAddResponse, OT>>(
    '/tk/account/pid/add',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除pid↗](https://yapi.fenxianglife.com/project/379/interface/api/45070) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/account/pid/delete`
 * @更新时间 `2023-10-23 12:01:23`
 */
export const feimaChatTkAccountPidDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkAccountPidDeleteRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatTkAccountPidDeleteResponse, OT>
  >('/tk/account/pid/delete', 'POST', data, options);

/**
 * 接口 [删除淘宝账户↗](https://yapi.fenxianglife.com/project/379/interface/api/45076) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/account/delete`
 * @更新时间 `2023-10-23 12:01:34`
 */
export const feimaChatTkAccountDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkAccountDeleteRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAccountDeleteResponse, OT>>(
    '/tk/account/delete',
    'POST',
    data,
    options
  );

/**
 * 接口 [修改备注↗](https://yapi.fenxianglife.com/project/379/interface/api/45082) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/account/remark`
 * @更新时间 `2023-10-23 12:01:43`
 */
export const feimaChatTkAccountRemark = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkAccountRemarkRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAccountRemarkResponse, OT>>(
    '/tk/account/remark',
    'POST',
    data,
    options
  );

/**
 * 接口 [商品分类↗](https://yapi.fenxianglife.com/project/379/interface/api/45088) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/getCategorys`
 * @更新时间 `2023-10-31 16:21:50`
 */
export const feimaChatTkGetCategorys = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatTkGetCategorysRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetCategorysResponse, OT>>(
    '/tk/getCategorys',
    'GET',
    data,
    options
  );

/**
 * 接口 [剧本详情↗](https://yapi.fenxianglife.com/project/379/interface/api/45166) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/getScript`
 * @更新时间 `2023-10-31 16:58:12`
 */
export const feimaChatTkGetScript = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetScriptRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetScriptResponse, OT>>(
    '/tk/getScript',
    'GET',
    data,
    options
  );

/**
 * 接口 [添加智能导购↗](https://yapi.fenxianglife.com/project/379/interface/api/45190) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/addGuide`
 * @更新时间 `2023-10-25 15:56:52`
 */
export const feimaChatTkAddGuide = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatTkAddGuideRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkAddGuideResponse, OT>>(
    '/tk/addGuide',
    'POST',
    data,
    options
  );

/**
 * 接口 [微信智能体状态↗](https://yapi.fenxianglife.com/project/379/interface/api/45208) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/getRobotStatus`
 * @更新时间 `2023-10-31 16:22:19`
 */
export const feimaChatTkGetRobotStatus = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetRobotStatusRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGetRobotStatusResponse, OT>>(
    '/tk/getRobotStatus',
    'GET',
    data,
    options
  );

/**
 * 接口 [查看对话数据↗](https://yapi.fenxianglife.com/project/379/interface/api/45256) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/getGuideDialogues`
 * @更新时间 `2023-10-31 16:23:27`
 */
export const feimaChatTkGetGuideDialogues = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGetGuideDialoguesRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatTkGetGuideDialoguesResponse, OT>
  >('/tk/getGuideDialogues', 'POST', data, options);

/**
 * 接口 [剧本详情页同步群聊↗](https://yapi.fenxianglife.com/project/379/interface/api/45280) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/syncGroup`
 * @更新时间 `2023-10-26 16:54:38`
 */
export const feimaChatTkSyncGroup = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatTkSyncGroupRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkSyncGroupResponse, OT>>(
    '/tk/syncGroup',
    'POST',
    data,
    options
  );

/**
 * 接口 [剧本批量启动↗](https://yapi.fenxianglife.com/project/379/interface/api/45292) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/startScript`
 * @更新时间 `2023-11-01 09:39:36`
 */
export const feimaChatTkStartScript = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkStartScriptRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkStartScriptResponse, OT>>(
    '/tk/startScript',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除智能体微信号↗](https://yapi.fenxianglife.com/project/379/interface/api/45304) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/deleteRobot`
 * @更新时间 `2023-10-27 12:07:55`
 */
export const feimaChatTkDeleteRobot = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkDeleteRobotRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkDeleteRobotResponse, OT>>(
    '/tk/deleteRobot',
    'POST',
    data,
    options
  );

/**
 * 接口 [群内商品列表↗](https://yapi.fenxianglife.com/project/379/interface/api/45874) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/group/items`
 * @更新时间 `2023-11-10 16:42:59`
 */
export const feimaChatTkGroupItems = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGroupItemsRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatTkGroupItemsResponse, OT>>(
    '/tk/group/items',
    'GET',
    data,
    options
  );

/**
 * 接口 [创建淘客客服智能体↗](https://yapi.fenxianglife.com/project/379/interface/api/45880) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/createTkChatBot`
 * @更新时间 `2023-12-14 15:56:08`
 */
export const feimaChatTkCreateTkChatBot = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatTkCreateTkChatBotRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatTkCreateTkChatBotResponse, OT>
  >('/tk/createTkChatBot', 'POST', data, options);

/**
 * 接口 [文本拆分问答↗](https://yapi.fenxianglife.com/project/379/interface/api/45886) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `POST /tk/util/splitQuestion`
 * @更新时间 `2023-12-14 15:56:09`
 */
export const feimaChatTkUtilSplitQuestion = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkUtilSplitQuestionRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatTkUtilSplitQuestionResponse, OT>
  >('/tk/util/splitQuestion', 'POST', data, options);

/**
 * 接口 [群内商品转链↗](https://yapi.fenxianglife.com/project/379/interface/api/47626) 的 **请求函数**
 *
 * @分类 [淘客相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10393)
 * @请求头 `GET /tk/group/item/convert`
 * @更新时间 `2024-01-29 17:54:37`
 */
export const feimaChatTkGroupItemConvert = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatTkGroupItemConvertRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatTkGroupItemConvertResponse, OT>
  >('/tk/group/item/convert', 'GET', data, options);

/* prettier-ignore-end */
